import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BgIndexPackageService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Fetch all BG Index mappings
  getIndex() {
    return this.http.get<any[]>(`${this.apiUrl}bg_index_package`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to load Index_Mapping', err);
        return of([]); // Return an empty array on error
      }),
    );
  }

  // Update a specific BG Index mapping
  updateIndex(bgIndexCode: string, updatedData: any) {
    return this.http.put<any>(`${this.apiUrl}bg_index_package/${bgIndexCode}`, updatedData).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to update Index Mapping', err);
        return of(null); // Return null on error
      }),
    );
  }

  // Create a new BG Index mapping
  createMapping(newMapping: any) {
    return this.http.post<any>(`${this.apiUrl}bg_index_package`, newMapping).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to create new Index Mapping', err);
        return of(null);
      }),
    );
  }

  // Delete bg-id 
  delete(mapping:any){
    return this.http.delete(`${this.apiUrl}bg_index_package/${mapping.bg_index_code}/${mapping.id}`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to create new Index Mapping', err);
        return of(null);
      }),
    )
  }
}
